import { EUserPermission, IUserProfile } from '../../types';
import { createSliceSteamup } from '../common';

interface IUserInfoState {
  isLoaded: boolean;
  isRequiredPasswordChange: boolean;
  loadMessage: string;
  profile: IUserProfile;
}

const initialState: IUserInfoState = {
  isLoaded: false,
  isRequiredPasswordChange: false,
  loadMessage: '',
  profile: {
    uuid: '',
    name: '',
    avatarUrl: '',
    email: '',
    permission: EUserPermission.VISITOR,
    profileBackgroundUrl: '',
    socialProvider: [],
    agreeAt: new Date(),
    createdAt: new Date(),
    lastActionAt: new Date(),
    money: {
      mileage: 0,
      point: 0,
    },
    contentsCnt: 0,
    classRoomsCnt: 0,
    followerCnt: 0,
    shortIntroduction: '',
    longIntroduction: '',
    actualName: '',
    belong: '',
    phone: '',
  },
};

const userInfoSlice = createSliceSteamup(
  'userInfo',
  initialState,
  {
    initProfile(state) {
      state.profile = initialState.profile;
    },
  },
);

export default userInfoSlice;
